export interface ClientPortalPasswordFields {
  clientResultsPassword?: string
  clientResultsPasswordHash?: string
  clientResultsPasswordSalt?: string
  clientResultsPasswordUpdatedAt?: string
}

const normalizePortalPassword = (password: string) => password.normalize('NFKC').trim()

const bytesToHex = (bytes: Uint8Array) => (
  Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
)

const createSalt = () => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return bytesToHex(bytes)
}

export const hashClientPortalPassword = async (password: string, salt: string) => {
  if (!window.crypto?.subtle) {
    throw new Error('Criptografia indisponivel neste navegador.')
  }

  const payload = new TextEncoder().encode(`${salt}:${normalizePortalPassword(password)}`)
  const digest = await window.crypto.subtle.digest('SHA-256', payload)
  return bytesToHex(new Uint8Array(digest))
}

export const createClientPortalPasswordCredentials = async (password: string) => {
  const salt = createSalt()
  return {
    clientResultsPasswordHash: await hashClientPortalPassword(password, salt),
    clientResultsPasswordSalt: salt,
    clientResultsPasswordUpdatedAt: new Date().toISOString(),
    clientResultsPassword: undefined,
  }
}

export const verifyClientPortalPassword = async (
  password: string,
  survey: ClientPortalPasswordFields
) => {
  const normalizedPassword = normalizePortalPassword(password)

  if (survey.clientResultsPasswordHash && survey.clientResultsPasswordSalt) {
    const inputHash = await hashClientPortalPassword(normalizedPassword, survey.clientResultsPasswordSalt)
    if (inputHash === survey.clientResultsPasswordHash) return true
  }

  const legacyPassword = survey.clientResultsPassword || ''
  return legacyPassword === password || normalizePortalPassword(legacyPassword) === normalizedPassword
}
